import { Box, Badge } from "@mui/material";

import { useTheme } from "@mui/material/styles";
import { NotificationIcon } from "../../../components/UIElements/svgIcons";
import { useAuth } from "../../../hooks/useAuth";

const NotificationContainer = () => {
  const { handleNotification, isNotification } = useAuth();
  const theme = useTheme();

  return (
    <div
      style={{
        position: "relative",
      }}
    >
      <Box
        onClick={handleNotification}
        sx={{
          borderRadius: "20px",
          width: "38px",
          height: "38px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: theme.palette.primary.main,
          background: theme.palette.lightBlue.main,
          cursor: "pointer",
        }}
      >
        <Badge color="error" variant={isNotification ? "dot" : "standard"}>
          <NotificationIcon />
        </Badge>
        {/* <AlarmIcon /> */}
      </Box>
      {/* Show backdrop if notification container is open */}
    </div>
  );
};

export default NotificationContainer;
